import { gql } from '@apollo/client';

const STOCK_CAR_FRAGMENT = gql`
  fragment StockCarFrament on StockCar {
    titleText
    engineInfo {
      fuel {
        text
      }
    }
    qualityLabel {
      name
    }
    dynamicAttributes {
      id
      value
    }
  }
`;

export const STOCKCAR_DETAILS_QUERY = gql`
  query StockCar($stockCarIdentifier: StockCarIdentifierInput!) {
    stockCar(stockCarIdentifier: $stockCarIdentifier) {
      ...StockCarFrament
    }
  }
  ${STOCK_CAR_FRAGMENT}
`;

export const STOCKCAR_SEARCH_QUERY = gql`
  query stockCarSearch(
    $stockIdentifier: StockIdentifierInput!
    $searchParameter: StockCarSearchParameterInput
  ) {
    stockCarSearch(stockIdentifier: $stockIdentifier, searchParameter: $searchParameter) {
      results {
        cars {
          stockCar {
            ...StockCarFrament
          }
        }
      }
    }
  }
  ${STOCK_CAR_FRAGMENT}
`;
